<template>
  <div class="h-full w-full">
    <div class="mt-8 mx-4">
      <h1 class="capitalize text-2xl font-semibold text-white mt-6 mb-2">Generar Spot Auditivo</h1>
      <Textarea v-model="prompt" autoResize rows="5" cols="30" class="w-5/5 mt-2 p-2 rounded" placeholder="Ingrese el prompt para generar el spot..." />
      <!-- <InputText autoResize rows="5" cols="30" type="text" v-model="prompt" class="w-2/5 mt-2 p-2 rounded" placeholder="Ingrese el prompt para generar el spot..." /> -->

      <!-- OPCIONES DEL PROMPT -->
      <div class="card flex flex-wrap gap-3 p-fluid mx-auto w-2/5">
        <div class="m-auto mt-4 mb-4 flex-1 flex justify-end w-3/5">
          <Dropdown v-model="radios" :options="radios" filter optionLabel="name" placeholder="Selecciona un canal" class="" />
          <!-- <Dropdown v-model="selectedRadio" :options="radios" filter optionLabel="name" placeholder="Selecciona un canal" class="w-full" >
              <template #value="slotProps">
                  <div v-if="slotProps.value" class="flex align-items-center">
                      <img :alt="slotProps.value" :src="'https://vybroo.net/images' + slotProps.value.image" class="mr-2 flag" />
                      <div>{{ slotProps.value.name }}</div>
                  </div>
                  <span v-else>
                      {{ slotProps.placeholder }}
                  </span>
              </template>
           
          </Dropdown>      -->

        </div>
        <!-- checkbox para activar las configuraciones manuales o automáticas del spot a generar: -->
          <!-- <Checkbox v-model="promptManualConfig" inputId="promptManualConfig" name="promptManualConfig" value="promptManualConfig" class="mr-2" /> -->
          <!-- <label for="promptManualConfig" class="">Configurar manualmente </label> -->

          <!-- cantidad de variantes de spots -->
          <div :v-show="promptManualConfig" class="m-auto mt-4 mb-4 flex-1 flex justify-end w-2/5">
            <label for="stacked-buttons" class="font-bold block mb-2 my-auto mr-2"> Cant. variantes: </label>
            <InputNumber v-model="numVariants" inputId="minmax-buttons" mode="decimal" showButtons :min="1" :max="6" class="w-1/5 input-maxvariants" regex="[1-4]" :validateRegex="[1-4]" />
          </div>
          <!-- duración del spot en segundos -->
          <div :v-show="promptManualConfig" class="m-auto mt-4 mb-4 w-5/5">
            <label for="stacked-buttons" class="font-bold block mb-2 my-auto mr-2"> Duración: </label>
            <InputNumber v-model="promptDuration" inputId="minmax-buttons" mode="decimal" showButtons :min="1" :max="180" class="w-1/5 input-maxvariants" regex="[1-4]" :validateRegex="[1-4]" />
          </div>
          <!-- cantidad de palabras máxima del prompt -->
          <div :v-show="promptManualConfig" class="m-auto mt-4 mb-4  w-5/5">
            <label for="stacked-buttons" class="font-bold block mb-2 my-auto mr-2"> Palabras máximas: </label>
            <InputNumber v-model="promptMaxWords" inputId="minmax-buttons" mode="decimal" showButtons :min="1" :max="600" class="w-1/5 input-maxvariants" regex="[1-4]" :validateRegex="[1-4]" />
          </div>

        <!-- boton centrado en la linea de abajo -->
        <div class="m-auto justify-center w-full">
          <button @click="generateVariants" class="mt-4 mb-8 bg-blue-600 hover:bg-blue-500 text-white px-4 py-2 rounded">Generar Variantes</button>
        </div>
      </div>
      
      <!-- VARIANTES DEL SPOT -->
      <div v-if="variants.length > 0" class="mt-8 mb-8">
        <div class="w-3/5 align-middle mx-auto mb-4">
          <h2>Variantes generadas:</h2>
          <ul>
            <li v-for="(variant, index) in variants" :key="index" :class="{ selected: index === selectedVariantIndex }" @click="selectVariant(index)">
              <div class="mb-4">
                <Panel :header="'#' + (index + 1)" class="panel-variantes mb-4" :class="{ 'p-highlight': index === selectedVariantIndex }" @click="selectVariant(index)">
                  <template #icons>
                    <button class="p-panel-header-icon p-link mr-2" @click="variant.editing = true" v-show="!variant.editing">
                      <font-awesome-icon icon="edit" class="text-white-600 hover:text-white-500" />
                    </button>
                    <button class="p-panel-header-icon p-link mr-2" @click="saveVariant(index)" v-show="variant.editing">
                      <font-awesome-icon icon="save" class="text-green-600 hover:text-green-500"/>
                    </button>
                  </template>
                    <p class="m-0 italic font-bold" v-if="!variant.editing">
                      "{{ variant.text }}"
                    </p>
                  <Textarea v-model="variant.text" v-show="variant.editing" :disabled="!variant.editing" class="w-100 mt-2 p-2 rounded" />
                </Panel>
              </div>
            </li>
          </ul>
        </div>
      </div>

      <!-- VOCES DISPONIBLES -->
      <div v-if="selectedVariantIndex !== null" class="mt-8 mb-4">
        <h2 class="text-lg font-semibold text-white">Seleccionar Voz para el Spot:</h2>
            <!-- listar las voces en forma horizontal como cuadrados redondeados -->
            <div class="grid grid-cols-12 gap-4">
              <div class="col-span-12">
                <label class="block mt-4">
                  <!-- <select v-model="selectedVoiceIndex" class="ml-2 p-2 rounded">
                    <option v-for="(voice, index) in availableVoices" :key="index" :value="index">
                      {{ voice.name }}
                    </option>
                  </select> -->

                  <!-- <Button label="Seleccionar voz" icon="pi pi-fw pi-microphone" @click="openPosition('top')" severity="success" style="min-width: 10rem" /> -->
                  <Dropdown v-model="selectedVoiceIndex" :options="availableVoices" optionLabel="name" filter placeholder="Selecciona una voz" class="w-2/5 text-left" @onSelect="obtenerConfiguracionesVoz">
                    <template #value="slotProps">
                        <div v-if="slotProps.value" class="flex align-items-center">
                            <div>{{ slotProps.value.name }}</div>
                        </div>
                        <span v-else>
                            {{ slotProps.placeholder }}
                        </span>
                    </template>
                    <template #option="slotProps">
                        <div class="flex align-items-center">
                          <button class="mr-2" @click="hear_preview(slotProps.option.preview_url)" title="Escuchar la voz">
                            <font-awesome-icon icon="play" class="text-white-600 hover:text-white-500" />
                          </button>

                            <div>{{ slotProps.option.name }}</div>
                            <!-- v-for para cada label, siempre mostrar un Tag con un color distinto cada vez -->
                            <div v-for="(label, index) in slotProps.option.labels" :key="index">
                            <Tag :style="{ background: 'linear-gradient(-225deg,#AC32E4 0%,#7918F2 48%,#4801FF 100%)', opacity: 0.9 }" class="ml-2 text-xs" rounded>
                              <div class="flex align-items-center gap-2"> 
                                <span class="text-xs font-normal text-white">{{ label }}</span>
                              </div> 
                            </Tag>
                            </div>
                            <!-- botón para configurar la voz -->
                            <button class="ml-2" @click="obtenerConfiguracionesVoz(slotProps.option.voice_id)" title="Cargar las configuraciones de esta voz">
                              <font-awesome-icon icon="cog" class="text-gray-600 hover:text-gray-500" />
                            </button>
                        </div>
                    </template>
                  </Dropdown>

                </label>
            <Accordion class="w-2/5 text-left mx-auto">
                <AccordionTab header="Configuraciones de la voz" :disabled="selectedVoiceIndex === null">
      <div class="items-center mb-4">
        <span class="text-md font-semibold mr-4">Estabilidad: <small>{{ voiceSettings.stability }}</small></span> 
        <!-- <InputText v-model="voiceSettings.stability" :min="0" :max="1" :step="0.01" class="ml-4 w-20" /> -->
        <Slider v-model="voiceSettings.stability" :min="0" :max="1" :step="0.01" class="flex-1" :handleTemplate="handleTemplate">
          <template #handleTemplate="{ value }">
            <div class="p-slider-handle-custom" :style="{ left: value + '%' }"></div>
          </template>
        </Slider>
        <div class="flex items-center gap-4">
          <div class="flex-1 text-left"><span class="text-xs">Más variable</span></div>
          <div class="flex-1 text-right"><span class="text-xs">Más estable</span></div>
        </div>

      </div>
      <div class="items-center mb-4">
        <span class="text-md font-semibold mr-4">Mejora de Claridad + Similitud: <small>{{ voiceSettings.similarity_boost }}</small></span>
        <!-- <InputText v-model="voiceSettings.similarity_boost" :min="0" :max="1" :step="0.1" class="ml-4 w-20" /> -->
        <Slider v-model="voiceSettings.similarity_boost" :min="0" :max="1" :step="0.1" class="flex-1" />
        <div class="flex items-center gap-4">
          <div class="flex-1 text-left"><span class="text-xs">Bajo</span></div>
          <div class="flex-1 text-right"><span class="text-xs">Alto</span></div>
        </div>
      </div>
      <div class="items-center mb-4">
        <span class="text-md font-semibold mr-4">Exageración de estilo: <small>{{ voiceSettings.style }}</small></span>
        <!-- <InputText v-model="voiceSettings.style" :min="0" :max="1" :step="0.1" class="ml-4 w-20" /> -->
        <Slider v-model="voiceSettings.style" :min="0" :max="1" :step="0.1" class="flex-1" />
        <div class="flex items-center gap-4">
          <div class="flex-1 text-left"><span class="text-xs">Nada (más rápido)</span></div>
          <div class="flex-1 text-right"><span class="text-xs">Exagerada</span></div>
        </div>
      </div>
      <div class="items-center mb-4">
        <div class="flex align-items-center">
            <Checkbox v-model="voiceSettings.boost" inputId="boost" name="boost" value="boost" class="mr-2" />
            <label for="boost" class="ml-2"> Boost de voz </label>
        </div>
      </div>
      

              </AccordionTab>
          </Accordion>
              </div>
            </div>

        <button @click="produceSpot" class="mt-4 mb-8 bg-blue-600 hover:bg-blue-500 text-white px-4 py-2 rounded" :disabled="selectedVoiceIndex === null">
          Producir Spot en Audio
        </button>
      </div>

      <!-- SPOT GENERADO -->
      <div class="grid grid-cols-12 mt-8 mb-8 gap-4" v-show="audioUrl.length > 0">
        <div class="col-span-12">
          <h2 class="text-lg font-semibold">Spot generado:</h2>
          <audio controls class="mx-auto" id="spot-player" :src="audioUrl" type="audio/mpeg"></audio>
          <button class="mt-4 bg-green-600 hover:bg-green-500 text-white px-4 py-2 rounded" @click="downloadSpot">
            Descargar Spot
          </button>
        </div>
      </div>

      <!-- DIALOGO DE SELECCIONAR VOZ -->              
      <Dialog v-model:visible="visible" header="Selecciona la voz" :style="{ width: '50vw' }" :position="position" :modal="true" :draggable="false">
          <div class="card flex justify-content-center">
              <Listbox v-model="selectedVoiceIndex" :options="availableVoices" filter optionLabel="apashurra una voz" class="w-full md:w-14rem" />
              <!-- boton de preview audio -->
              <button class="mr-2" @click="hear_preview(slotProps.option.preview_url)">
                <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5 text-blue-600 hover:text-blue-500" viewBox="0 0 20 20" fill="currentColor">
                  <path d="M5 4v12l10-6-10-6z" />
                </svg>
              </button>
          </div>
      </Dialog>
    </div>
  </div>
</template>

<script>
import { Configuration, OpenAIApi } from "openai";
import axios from "axios";
import axiosInstance from '../../axiosInstance';

export default {
  name: 'Spots',
  data() {
    return {
      organizationId: 'org-s43fxswvWFRPHW6jP0cAILz3',
      apiKey: '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',
      elevenlabs_apiKey: '5aee9347f346255fdc1fa0e55a08def9',
      items: [
        // ... tu configuración de PanelMenu ...
      ],
      prompt: '',
      fullPrompt: `Genera un texto para un spot de radio de ${this.promptDuration} segundos de duración. El texto se utilizará en un canal de radio online y se procesará para que una voz con IA lo lea automáticamente. Por favor, asegúrate de que el texto no exceda ${this.promptMaxWords} palabras. El mensaje debe ser persuasivo y atractivo para el público objetivo, que son [describir el público objetivo, por ejemplo, adultos jóvenes interesados en tecnología]. Evita detalles de producción y recuerda que será narrado por una sola voz. A continuación, proporciona el texto del spot de radio: `,
      promptDuration: 5,
      promptMaxWords: 15,
      promptManualConfig: false,
      numVariants: 4,
      variants: [],
      selectedVariantIndex: null,
      availableVoices: [],
      selectedVoiceIndex: null,
      audioUrl: "",
      voiceSettings:{
        stability: 0.3, similarity_boost: 1, style: 0, use_speaker_boost: false
      },
      position: 'top',
      visible: false,
      radios: [],
      selectedRadio: null,
    };
  },
  methods: {
    selectVariant(index) {
      console.log("Seleccionando variante " + (index + 1));
      this.selectedVariantIndex = index;
    },
    saveVariant(index) {
      this.variants[index].editing = false;
      // Aquí puedes agregar la lógica para guardar los cambios en la variante
    },
    openPosition(position) {
        this.position = position;
        this.visible = true;
    },
    hear_preview(preview_url) {
      const audio = new Audio(preview_url);
      audio.pause();
      audio.play();
    },
    async generateVariants() {
        try {
            //validar que this.prompt no esté vacío y que this.numVariants sea un número mayor a 0
            if (this.prompt === "" || this.numVariants <= 0 || this.numVariants > 6) {
                this.$toast.add({ severity: 'warn', summary: 'Aviso', detail: 'Debes ingresar un prompt y un número de variantes mayor a 0.', group: 'topr', life: 5000 });
                // alert("Debe ingresar un prompt y un número de variantes mayor a 0");
                this.numVariants = 4;
                return;
            }
            // Calcular la cantidad de tokens del prompt
            // const promptTokens = this.prompt.split(" ").length;

            //llamada a la API de OpenAI para generar las variantes del prompt
            console.log("Generando variantes...");
            console.log("Prompt: " + this.prompt)
            // console.log("Organización: " + this.organizationId);
            // console.log("API Key: " + this.apiKey);
            const openai_config = new Configuration({apiKey: this.apiKey});
            const openai = new OpenAIApi(openai_config);
            // trabajar prompt para que ponga en contexto a la IA, tratará de generar variantes de un prompt, principalmente de spots de radio
            // const fullPrompt = "Tu tarea es generar un texto para un spot, no deberás pasarte de los 100 caracteres pero tampoco dejar frases incompletas por ningún motivo, este texto será completamente basado en lo que solicite el prompt al final de este parrafo, el texto se usará en en un canal de radio online, lo que generes se procesará para que una voz con IA lo diga en automático tal cual lo dices por lo que no deberás incluír los detalles de producción y siempre serán para una sola voz por lo que omite también las distintas voces si lo pensabas sugerir. A continuación se muestra el prompt que se utilizará para generar los spots: \n\n" + this.prompt;
            // const fullPrompt = `\n\n${this.fullPrompt + this.prompt}`;
            const fullPrompt = `Genera un texto para un spot de radio de ${this.promptDuration} segundos de duración. El texto se utilizará en un canal de radio online y se procesará para que una voz con IA lo lea automáticamente. Por favor, asegúrate de que el texto no exceda ${this.promptMaxWords} palabras. El mensaje debe ser persuasivo y atractivo para el público objetivo, que son [describir el público objetivo, por ejemplo, adultos jóvenes interesados en tecnología]. Evita detalles de producción y recuerda que será narrado por una sola voz. A continuación, proporciona el texto del spot de radio: ` + this.prompt;
            console.log("Full prompt: " + fullPrompt);
            try {
              this.$emit('update-loading', true);
              const completion = await openai.createChatCompletion({
                  model: "gpt-3.5-turbo",
                  messages: [
                  {"role": "system", "content": "Hola, soy un bot que genera variantes de un prompt respetando estrictamente la duración y cantidad de palabras cuando se indique."},
                  {role: "user", content: fullPrompt}],
                  max_tokens: 150,
                  n: this.numVariants,
              });
              this.variants = [];
              for (let i = 0; i < completion.data.choices.length; i++) {
                  console.log("Variante " + (i + 1) + ": " + completion.data.choices[i].message.content);
                  // quitar las comillas dobles que genera la IA
                  completion.data.choices[i].message.content = completion.data.choices[i].message.content.replace(/"/g, "");
                  this.variants.push({ text: completion.data.choices[i].message.content, editing: false });

              }
              // desselect variant
              this.selectedVariantIndex = null;
              console.log("Variantes generadas: " + this.variants.length);
              console.log(this.variants);
            } catch (error) {
              console.error(error);
            } finally {
              this.$emit('update-loading', false);
            }
            
            // Actualizar this.variants con los resultados obtenidos
        } catch (error) {
            console.error(error);
        }
    },
    async obtenerVocesDisponibles() {
      try {
        this.$emit('update-loading', true);
        //llamada a la API de ElevenLabs para obtener las voces disponibles
        console.log("Obteniendo voces disponibles...");
        await axios.get('https://api.elevenlabs.io/v1/voices', {
          headers: {
            'accept': 'application/json',
            'xi-api-key': this.elevenlabs_apiKey
          }
        })
        .then(response => {
          console.log(response.data);
          //solo las voces que tengan la propiedad de category en "cloned", es un array de este tipo de objetos: 1: {voice_id: '2EiwWnXFnvU5JabPnv8n', name: 'Clyde', samples: null, category: 'premade', fine_tuning: {…}, …}
          for (let i = 0; i < response.data.voices.length; i++) {
            if (response.data.voices[i].category !== "cloned") {
              this.availableVoices.push(response.data.voices[i]);
            }
          }
          console.log("Voces disponibles: " + this.availableVoices.length);
          console.log(this.availableVoices.map(voice => JSON.parse(JSON.stringify(voice))));
          //imprimir en consola cada voice_id de las voces disponibles
          for (let i = 0; i < this.availableVoices.length; i++) {
              console.log("voice_id: " + this.availableVoices[i].voice_id);
          }
        })
        .catch(error => {
          console.log(error);
        });
      } catch (error) {
        console.error(error);
      } finally {
        this.$emit('update-loading', false);
      }
    },
    async obtenerConfiguracionesVoz(voice_id) {
        //validar que voice_id no sea null
        if (voice_id === null) {
          this.$toast.add({ severity: 'warn', summary: 'Aviso', detail: 'Debes seleccionar una voz.', group: 'topr', life: 5000 });
          return;
        } else {
          console.log("Obteniendo configuraciones de voz...");
          console.log("voice_id: " + voice_id);
        }
        // obtener las voice_settings de la voz seleccionada haciendo un get a https://api.elevenlabs.io/v1/voices/{voice_id}/settings
        await axios.get('https://api.elevenlabs.io/v1/voices/' + voice_id + '/settings', {
          headers: {
            'accept': 'application/json',
            'xi-api-key': this.elevenlabs_apiKey
          }
        })
        .then(response => {
          console.log(response.data);
          this.voiceSettings = response.data;
        })
    },
    async produceSpot() {
      try {
        //validar que this.selectedVariantIndex no sea null y que this.selectedVoiceIndex no sea null
        if (this.selectedVariantIndex === null || this.selectedVoiceIndex === null) {
          this.$toast.add({ severity: 'warn', summary: 'Aviso', detail: 'Debes seleccionar una variante y una voz.', group: 'topr', life: 5000 });
          return;
        }
        console.log(this.availableVoices);
        console.log(this.selectedVoiceIndex);
        console.log(this.availableVoices[this.selectedVoiceIndex]);
        console.log(this.availableVoices[this.selectedVoiceIndex]?.voice_id ?? "no hay voice_id");
        //buscar en el array de availableVoices el objeto que tenga el voice_id seleccionado
        const selectedVoice = this.availableVoices.find((voice) => voice.voice_id === this.selectedVoiceIndex.voice_id);
        console.log("Voz seleccionada:");
        console.log(selectedVoice.voice_id);

        //llamada a la API de ElevenLabs para producir el spot
        console.log("Produciendo spot...");
        console.log("Variante seleccionada: " + this.variants[this.selectedVariantIndex]);
        console.log("Voz seleccionada: " + selectedVoice.voice_id);
        this.$emit('update-loading', true);
        this.audioUrl = "";

        await axios.post('https://api.elevenlabs.io/v1/text-to-speech/' + selectedVoice.voice_id, {
          text: this.variants[this.selectedVariantIndex].text,
          model_id: "eleven_multilingual_v1",
          voice_settings: this.voiceSettings
        }, {
          headers: {
            'accept': 'accept: audio/mpeg',
            'xi-api-key': this.elevenlabs_apiKey,
            'Content-Type': 'application/json'
          },
          responseType: 'arraybuffer'
        })
        .then(response => {
          // console.log(response.data);
          // Crear un objeto Blob a partir de los datos binarios recibidos
          const blob = new Blob([response.data], { type: 'audio/mp3' });
          this.audioUrl = URL.createObjectURL(blob);
          const audio = new Audio(this.audioUrl);
          console.log("Audio URL: " + this.audioUrl);
          const spotPlayer = document.getElementById('spot-player');
          spotPlayer.src = this.audioUrl;

          // Crear un link para descargar el audio
          

          const link = document.createElement('a');
          link.href = this.audioUrl;
          // nombre del archivo
          link.download = 'spot.mp3';
          
          //insertar el link abajo del spotPlayer
          spotPlayer.insertAdjacentElement('afterend', link);
          // fecha y hora para nombre de archivo




          const hora = new Date();
          const fecha = hora.getDate() + "-" + (hora.getMonth() + 1) + "-" + hora.getFullYear();
          // hora y fechas legibles para formato de archivo
          const horaLegible = hora.getHours() + "-" + hora.getMinutes() + "-" + hora.getSeconds();
          link.download = 'spot - ' + fecha + ' - ' + horaLegible + '.mp3';
          document.body.appendChild(link);
          // console.log("Duración leible: " + this.formatTime(audio.duration));
          audio.play();
          console.log("Spot producido");
        })
        .catch(error => {
          console.log(error);
        });
      } catch (error) {
        console.error(error);
      } finally {
        this.$emit('update-loading', false);
      }
  },
  async consultarRadios(){
    //axiosInstance get con el token a la dirección /api/radios
    try {
      this.$emit('update-loading', true);
      const radios = await axiosInstance.post('/api/radios', {
        token: localStorage.getItem('token')
      });
      console.log(radios);
      this.radios = radios.data.items;  
    } catch (error) {
      console.error(error);
    } finally {
      this.$emit('update-loading', false);
    } 

  }

  // funcion para convertir el spot generado a mp3 para poderlo descargar

},
mounted() {
  this.obtenerVocesDisponibles();
  const token = localStorage.getItem('token');
  console.log(token);
  this.consultarRadios();
}, 
};
</script>

<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  overflow-x: hidden;
}

#app h1 {
  font-size: 26px;
  font-weight: 600;
  margin: 0 0 20px;
}

#app h2 {
  font-size: 20px;
  font-weight: 600;
  margin: 0 0 20px;
}

#app h3 {
  font-size: 16px;
  font-weight: 600;
  margin: 0 0 20px;
}

#app textarea {
  /* cuadro de ancho fijo para que no se mueva al cambiar el contenido */
  width: 500px;
  height: 100px;
  vertical-align: top;
  font-size: 16px;
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #e1e1e1;
}


.selected {
  background-color: #8282822b;
  color: #fff;
}
.input-maxvariants{
  width: 100px !important;
}
.panel-variantes {
  background-color: #1e1e1e;
  color: #fff;
  border: 1px solid #1e1e1e;
  transition: all 0.2s ease-in-out;
}

.panel-variantes:not(.p-highlight):hover {
  cursor: pointer;
  border: 1px solid #4e8cbca1;
  transform: scale(1.01);
  transition: all 0.2s ease-in-out;
  cursor: pointer;
}

.panel-variantes .p-panel-header {
  padding: 0.2rem 1rem !important;
  font-size: 0.6rem !important;  
  }

.p-highlight {
  border: 1px solid #007ad9;
}

.p-slider {
  margin-top: 10px;
}

.p-slider-handle-custom{
  position: absolute;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  background-color: #4a5568;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.2);
  cursor: pointer;
}


button .disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.p-checkbox .p-checkbox-box {
  margin: auto 0;
}

</style>
